<template>
  <!-- 舆情-新增-舆情概况 -->
  <div class="add_negative">
    <div class="steps">
      <div class="step active">
        <span class="index">1</span>
        <span class="cont">舆情概况</span>
      </div>
      <div class="line"></div>
      <div class="step">
        <span class="index">2</span>
        <span class="cont">详细描述</span>
      </div>
      <div class="line"></div>
      <div class="step">
        <span class="index">3</span>
        <span class="cont">所涉州市</span>
      </div>
    </div>
    <div class="content">
      <div class="accident">
        <div class="tip">舆情标题</div>
        <div class="input">
          <input type="text" maxlength="50" v-model="opinionTitle" placeholder="请输入" />
        </div>
      </div>
      <div class="accident">
        <div class="tip">舆情级别</div>
        <div class="drop_down" @click="showQuarter">
          <span v-if="!selectQuarter.text">请选择</span>
          <span class="selected" v-if="selectQuarter.text">{{selectQuarter.text}}</span>
          <img src="@/assets/appraise/arrow_right.png" alt />
        </div>
      </div>
      <div class="accident">
        <div class="tip">问题分类</div>
        <div class="input">
          <input type="text" maxlength="100" v-model="opinionType" placeholder="请输入" />
        </div>
      </div>
    </div>
    <div class="bot_btns">
      <van-button @click="nextStep" type="primary" size="large">下一步</van-button>
    </div>
    <commonPicker
      ref="commonPickerQuarter"
      :typeList="newQuarterList"
      :title="title"
      :cols="cols1"
      @getTypeValue="getTypeValue"
    ></commonPicker>
    <tipDialog :isShow="showTips" :content="requireCont" @closeModal="showTips=false"></tipDialog>
  </div>
</template>

<script>
import commonPicker from "../../../components/base/myCommonPicker.vue";
import tipDialog from "./components/tipDialog";
export default {
  components: {
    commonPicker,
    tipDialog
  },
  data() {
    return {
      showTips: false,
      requireCont: '',
      opinionTitle: "", // 舆情标题
      opinionType: "", // 问题分类
      selectQuarter: {},
      quarter: this.$route.query.quarter,
      year: this.$route.query.year,
      area: this.$route.query.area,
      newQuarterList: [
        [
          { id: "one", text: "一级负面舆情" },
          { id: "two", text: "二级负面舆情" },
          { id: "three", text: "三级负面舆情" },
          { id: "normal", text: "一般负面舆情" }
        ]
      ],
      cols1: 1,
      title: ""
    };
  },
  created() {
   this.initData();
  },
  methods: {
   initData() {
    let negativeSummary = this.$store.state.appraise.negativeSummary;
    if (negativeSummary.opinionTitle) {
     this.opinionTitle = negativeSummary.opinionTitle;
     this.opinionType = negativeSummary.opinionType;
     this.selectQuarter = (this.newQuarterList[0].filter(item => {
      return item.id == negativeSummary.opinionLevel
     }))[0];
    }
   },
   
    // 下一步
    nextStep() {
      if(this.opinionTitle == '') {
        this.showTips = true;
        this.requireCont = '请填写“舆情标题”';
        return
      } else if(!this.selectQuarter.text) {
        this.showTips = true;
        this.requireCont = '请选择“舆情级别”';
        return
      } else if(this.opinionType == '') {
        this.showTips = true;
        this.requireCont = '请填写“问题分类”';
        return
      }
      // if(this.$store.state.appraise.negativeSummary.opinionTitle) {
      //   this.$router.push(`/appraise/addNegativeDesc?id=${this.$route.query.id}&year=${this.year}&quarter=${this.quarter}&area=${this.area}`);
      // } else {
        let data = {
          opinionTitle: this.opinionTitle,
          opinionType: this.opinionType,
          opinionLevel: this.selectQuarter.id
        }
        this.$store.commit('appraise/setNegativeSummary', data);
        this.$router.replace(`/appraise/addNegativeDesc?id=${this.$route.query.id}&year=${this.year}&quarter=${this.quarter}&area=${this.area}`);
      // }
    },
    showQuarter() {
      // 唤起事故等级选择组件
      this.$refs.commonPickerQuarter.showPicker();
    },
    // 选中舆情级别回调
    getTypeValue(value) {
      this.selectQuarter = value[0];
    }
  }
};
</script>

<style scoped lang="less">
.steps {
  padding: 25px 12px;
  background-color: #fbfbfb;
  & > div {
    display: inline-block;
  }
  .step.active {
    .cont {
      color: #36b374;
    }
    .index {
      background-color: #36b374;
    }
  }
  .index {
    display: inline-block;
    margin-right: 4px;
    width: 16px;
    height: 16px;
    line-height: 16px;
    font-size: 10px;
    color: #fff;
    text-align: center;
    // background-color: #36B374;
    background-color: #ccc;
    border-radius: 50%;
    vertical-align: text-bottom;
  }
  .line {
    display: inline-block;
    margin: 0 11px;
    width: 38px;
    height: 1px;
    background-color: #ccc;
    vertical-align: middle;
  }
  .cont {
    font-size: 14px;
    color: #ccc;
  }
}
.content {
  padding: 0 12px;
}
.accident {
  display: flex;
  justify-content: space-between;
  padding: 16px 0;
  height: 46px;
  border-bottom: 1px solid #ededed;
  .tip {
    color: #666;
    font-size: 14px;
  }
  .input input {
    width: 280px;
    font-size: 14px;
    text-align: right;
  }
  .input input::-webkit-input-placeholder {
    font-size: 14px;
    color: #ccc;
    text-align: right;
  }
  .drop_down {
    span {
      margin-right: 4px;
      color: #ccc;
      font-size: 14px;
    }
    img {
      display: inline-block;
      width: 12px;
      height: 12px;
      vertical-align: text-top;
    }
    span.selected {
      color: #333;
      font-size: 14px;
    }
  }
}
.bot_btns {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px 12px;
  height: 60px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.03);
  .van-button {
    width: 351px;
    height: 40px;
    background-color: #36b374;
  }
}
.van-dialog {
  background-color: red;
}
</style>